module.exports = __webpack_public_path__ + "img/nt114-06-81-1.prt.af5ea664.jpg";